// config.js
// النسخة الأونلاين: الواجهة والسيرفر على نفس العنوان (https://system.nisrelkhaleeg.com)
// فكل الطلبات بتروح لنفس الموقع: /api/... و wss://نفس-الموقع
// وقت التطوير (npm start على بورت 3000) الطلبات بتتحوّل للسيرفر عن طريق "proxy" في package.json.

// عنوان الموقع نفسه كامل (مش فاضي): بعض الشاشات بتعتبر العنوان الفاضي «مفيش سيرفر»
const sameOrigin = (typeof window !== 'undefined' && window.location) ? window.location.origin : '';
const wsBase = (typeof window !== 'undefined' && window.location)
    ? `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}`
    : '';

const buildConfig = () => {
    const base = sameOrigin;

    return {
        SERVER_IP: typeof window !== 'undefined' ? window.location.hostname : '',
        API_BASE_URL: base,
        PASSPORT_API_URL: base,
        TREASURY_API_URL: base,
        REPORTS_API_URL: base,
        WHATSAPP_API_URL: base,
        WHATSAPP_WS_URL: wsBase,
        WS_BASE_URL: wsBase,
        FLIGHT_API_URL: base,
        BANKS_API_URL: base,
        CLIENTS_API_URL: base,
        DELEGATES_API_URL: base,
        NET_REGISTRATIONS_API_URL: base,
        COMPANY_MANAGEMENT_API_URL: base,
        DELEGATES_MANAGEMENT_API_URL: base,
        PROFESSIONS_API_URL: base,
        VISA_MANAGEMENT_API_URL: base,
        VISA_REPORTS_API_URL: base,
        USER_MANAGEMENT_API_URL: base,
        DATA_IMPORT_API_URL: base,
        HUMAN_RESOURCES_API_URL: base,
        FINANCIAL_REPORTS_API_URL: base,
        PERIODIC_FOLLOW_UP_API_URL: base,
        CONSULATE_PREPARATION_API_URL: base,
        ARCHIVE_MANAGEMENT_API_URL: base,
        COMPANY_TRANSACTIONS_API_URL: base,
    };
};

const config = buildConfig();

// كانت بتحفظ IP السيرفر يدوياً. في النسخة الأونلاين مفيش IP — بتمسح أي قيمة قديمة وبس.
export const setManualServerIP = () => {
    localStorage.removeItem('manualServerIP');
    window.location.reload();
};

export const clearManualServerIP = () => {
    localStorage.removeItem('manualServerIP');
    localStorage.removeItem('systemURLs');
    localStorage.removeItem('systemURLs_backup');
    localStorage.removeItem('serverIP');
    window.location.reload();
};

export default config;
